// Helper function to extract try/catch error message
export default function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error);
}
